import { cn } from '@/lib/utils'

interface IconProps {
  className?: string
  size?: number
}

interface YoutubeMusicProps extends IconProps {
  /** Quando true, permite tamanho pequeno (ex.: h-3 w-3) igual a outros ícones em dropdowns */
  allowSmallSize?: boolean
}

export const Google = ({ className, size = 30 }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width={size} height={size} className={className}>
      <path
        fill="#FFC107"
        d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
      />
      <path
        fill="#FF3D00"
        d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
      />
      <path
        fill="#4CAF50"
        d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
      />
      <path
        fill="#1976D2"
        d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
      />
    </svg>
  )
}

export const Spotify = ({ className, size = 30 }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 66" width={size} height={size} className={className}>
    <path
      d="M32 0C14.3 0 0 14.337 0 32c0 17.7 14.337 32 32 32 17.7 0 32-14.337 32-32S49.663 0 32 0zm14.68 46.184c-.573.956-1.797 1.223-2.753.65-7.532-4.588-16.975-5.62-28.14-3.097-1.07.23-2.14-.42-2.37-1.49s.42-2.14 1.49-2.37c12.196-2.79 22.67-1.606 31.082 3.556a2 2 0 0 1 .688 2.753zm3.9-8.717c-.726 1.185-2.256 1.53-3.44.84-8.602-5.276-21.716-6.805-31.885-3.747-1.338.382-2.714-.344-3.097-1.644-.382-1.338.344-2.714 1.682-3.097 11.622-3.517 26.074-1.835 35.976 4.244 1.147.688 1.49 2.217.765 3.403zm.344-9.1c-10.323-6.117-27.336-6.69-37.2-3.708-1.568.497-3.25-.42-3.747-1.988s.42-3.25 1.988-3.747c11.317-3.44 30.127-2.753 41.98 4.282 1.415.84 1.873 2.676 1.032 4.09-.765 1.453-2.638 1.912-4.053 1.07z"
      fill="#1ed760"
    />
  </svg>
)

export const AppleMusic = ({ className, size = 30 }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" aria-label="Apple Music" role="img" viewBox="0 0 512 512" width={size} height={size} className={className}>
    <rect width="512" height="512" rx="15%" fill="url(#g)" />
    <linearGradient id="g" x1=".5" y1=".99" x2=".5" y2=".02">
      <stop offset="0" stopColor="#FA233B" />
      <stop offset="1" stopColor="#FB5C74" />
    </linearGradient>
    <path
      fill="#ffffff"
      d="M199 359V199q0-9 10-11l138-28q11-2 12 10v122q0 15-45 20c-57 9-48 105 30 79 30-11 35-40 35-69V88s0-20-17-15l-170 35s-13 2-13 18v203q0 15-45 20c-57 9-48 105 30 79 30-11 35-40 35-69"
    />
  </svg>
)

export const AppleLogo = ({ className, size = 30 }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Apple"
    role="img"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    fill="currentColor"
  >
    <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" />
  </svg>
)
export const Deezer = ({ className, size = 30 }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Calque 1" viewBox="0 0 135.47 135.71" width={size} height={size} className={className}>
    <path
      fill="#a239ff"
      d="M41.27 25.87c1.14-5.64 1.99-11.61 5.45-16.57.65-.93 1.92-1.16 2.85-.52.08.06.16.12.23.19 5.41 5.05 7.25 25.59 7.54 32.31.13 3.04.53 3.07 1.2.1.95-4.25 6.39-19.91 12.97-12.13 3.1 3.66 4.95 8.27 5.54 13.84.01.15.09.24.23.29l.34.12c.21.08.44-.03.51-.23.02-.04.02-.08.03-.13.28-7.85 1.25-15.63 2.92-23.35.56-2.61 2.74-11.53 6.12-11.23 4.29.38 6.62 14.47 6.76 17.94.01.28.16.42.44.43h.27c.11.01.17-.05.18-.16.46-6.83 1.85-13.46 4.16-19.9.91-2.53 2.21-4.61 3.91-6.24.8-.77 2.05-.85 2.94-.18 4.89 3.65 6.87 13.18 7.15 18.85.02.33.19.46.51.37l.28-.08q.165-.045.18-.21c.43-3.49 1.53-6.74 3.31-9.74a1.485 1.485 0 0 1 2.25-.37c3.36 2.86 4.55 11.38 5.01 15.56 1.47 13.2 1.46 26.4-.05 39.59-.67 5.8-1.54 10.75-4.44 14.71-.54.74-1.57.89-2.31.36-.01 0-.02-.02-.03-.03-1.83-1.43-1.75-3.68-2.72-5.54a.34.34 0 0 0-.45-.14c-.1.05-.16.15-.17.26-.7 7.53-2.17 14.38-4.4 20.54-.96 2.65-4.49 8.76-8.04 4.24-2.77-3.53-4.51-8.42-5.05-12.54-.51-3.87-.87-3.85-1.08.07-.31 5.54-2.39 28.4-8 31.27-.9.46-2 .18-2.56-.66-2.71-4.07-3.31-7.92-4.68-12.43a.273.273 0 0 0-.33-.19.28.28 0 0 0-.2.25c-.38 4.94-1.17 9.95-2.36 15.02-.87 3.68-5.56 19.59-12.19 15.4-6.21-3.93-9.48-22.9-9.92-30.2-.11-1.89-.37-1.91-.77-.06-.95 4.43-1.84 8.92-4.98 12.66-.62.74-1.72.84-2.46.22-.1-.08-.19-.18-.27-.29-2.06-2.71-3.5-5.87-4.31-9.46-1.72-7.55-2.73-14.84-3.02-21.86-.12-2.87-.45-2.89-.99-.07-.83 4.33-2.54 10.69-6.19 13.97-2 1.79-4.52-.52-5.54-2.47-3.56-6.8-5.01-15.09-5.93-22.58-.15-1.19-.52-1.27-1.13-.24q-.165.285-.36 1.41c-.24 1.48-.95 2.6-2.13 3.37q-1.575 1.02-2.55-.57c-2.83-4.62-3.79-12.38-4.31-17.71-.89-9.1-2.51-47.14 5.95-52.4.3-.19.57-.16.81.11 2.95 3.22 2.68 5.89 3.96 9.58.43 1.26.75 1.23.95-.09.49-3.31 5.11-26.21 12.37-15.45 3.57 5.29 5.01 15.71 6.11 22.98.14.93.3.94.49.01"
    />
    <ellipse cx="3.89" cy="40.87" fill="#a239ff" rx="3.89" ry="15.85" />
    <ellipse cx="131.61" cy="40.9" fill="#a239ff" rx="3.86" ry="15.83" />
  </svg>
)

export const Tidal = () => (
  <svg
    fill="#000000"
    width="800px"
    height="800px"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.016 5.323l-5.339 5.339-5.339-5.339-5.339 5.339 5.339 5.339 5.339-5.339 5.339 5.339-5.339 5.339 5.339 5.339 5.339-5.339-5.339-5.339 5.339-5.339zM21.391 10.661l5.302-5.307 5.307 5.307-5.307 5.307z" />
  </svg>
)

export const YoutubeMusic = ({ className, size = 30, allowSmallSize = false }: YoutubeMusicProps) => {
  const pixelSize = allowSmallSize ? size : Math.max(size, 14)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={pixelSize}
      height={pixelSize}
      aria-hidden="true"
      className={cn('shrink-0 text-red-500', className)}
      style={allowSmallSize ? undefined : { minWidth: pixelSize, minHeight: pixelSize }}
    >
      <rect x="8" y="11" width="32" height="26" rx="6" fill="none" stroke="currentColor" strokeWidth="3" />
      <path fill="currentColor" d="M21 18.5v11l10-5.5-10-5.5z" />
    </svg>
  )
}
